import { Route } from '@angular/router';

const loadErrorRoutes = () =>
  import('@mimecast-ui/universal-login/feature-login').then(
    (m) => m.errorRoutes
  );

export const appRoutes: Route[] = [
  {
    path: 'login',
    loadChildren: () =>
      import('@mimecast-ui/universal-login/feature-login').then(
        (m) => m.loginRoutes
      ),
  },
  {
    path: 'errors',
    loadChildren: loadErrorRoutes,
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '**',
    loadChildren: loadErrorRoutes,
  },
];
